import gql from 'graphql-tag';

export const GetExams = gql`
  query GetExams($query: ExamQuery!) {
    getExams(query: $query) {
      year
      disciplines {
        discipline {
          _id
          name
        }
        exams {
          _id
          name
          year
          content
        }
      }
    }
  }
`;
